var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-page-layout',{staticClass:"googlelayout"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"600","height":"450","frameborder":"0","src":"https://www.google.com/maps/?q=-15.623037,18.388672","allowfullscreen":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ddaf53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoogleMap.vue
// module id = 455
// module chunks = 1